module.exports = __webpack_public_path__ + "static/img/hyh.9543c999.png";